/**
 * Compact Time Formatting for Notifications
 *
 * Produces short, space-efficient time labels like "2h ago" instead of
 * the verbose "about 2 hours ago" from date-fns formatDistanceToNow.
 */

import { differenceInMinutes, differenceInHours, differenceInDays, parseISO } from 'date-fns';

/**
 * Format a date string as a compact relative time label.
 *
 * @param dateStr - ISO 8601 date string
 * @returns Compact time label (e.g., "just now", "5m ago", "3h ago", "yesterday", "Mon 20")
 */
export function timeAgo(dateStr: string): string {
  const date = parseISO(dateStr);
  const now = new Date();

  const mins = differenceInMinutes(now, date);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;

  const hours = differenceInHours(now, date);
  if (hours < 24) return `${hours}h ago`;

  const days = differenceInDays(now, date);
  if (days === 1) return 'yesterday';
  if (days < 7) return `${days}d ago`;

  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}
